const oidcConfig = {
  clientId: process.env.REACT_APP_CLIENT_ID || '',
  scope: process.env.REACT_APP_SCOPE || 'openid',
  redirectUri: window.location.origin + '/home',
  idp: process.env.REACT_APP_IDP || 'IAMSSO',
  authEndpoint: process.env.REACT_APP_AUTH_ENDPOINT_URI || '',
  tokenEndpoint: process.env.REACT_APP_GET_TOKEN_ENDPOINT_URI || '',
  logoutEndpoint: process.env.REACT_APP_LOGOUT_ENDPOINT_URI || '',
  revokeEndpoint: process.env.REACT_APP_REVOKE_ENDPOINT_URI || '',
  pkmsLogout: process.env.REACT_APP_PKMS_LOGOUT || '',
};

export default oidcConfig;
